var React = require('react');

function VirtualTour (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2857 0C15.9664 0 20.5714 2.81421 20.5714 6.28571C20.5714 8.46481 18.7569 10.3849 16.0009 11.5126L16.0001 9.00392C17.4296 8.24251 18.2857 7.24169 18.2857 6.28571C18.2857 4.37527 14.8664 2.28571 10.2857 2.28571C5.70499 2.28571 2.28571 4.37527 2.28571 6.28571C2.28571 8.05803 5.22843 9.9845 9.31121 10.2538L7.53143 8.47339L9.14767 6.85714L13.7191 11.4286L9.14767 16L7.53143 14.3838L9.3693 12.5468C4.11795 12.2635 0 9.56848 0 6.28571C0 2.81421 4.60507 0 10.2857 0Z","fill":"currentColor"}));
}

VirtualTour.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 21 16","fill":"none"};

module.exports = VirtualTour;

VirtualTour.default = VirtualTour;
